export default "__VITE_ASSET__DvCsQsXd__"